import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { getFiltroPadraoRelatorioEstoque } from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import { baixarArquivoBase64 } from '../../utils/download';
import Filtros from '../../components/Filtros/Filtros';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import Tabela from '../../components/Tabela/Tabela';
import InputToggle from './../../components/Inputs/InputToggle/InputToggle';

function RelEstoque() {
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [relEstoque, setRelEstoque] = useState([]);

  async function GetRelEstoque(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/EstoqueReport/GetList', payload);
    let data = res.data;
    if (res.status === 200) {
      setRelEstoque(data.Produtos);
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    GetRelEstoque(getFiltroPadraoRelatorioEstoque());
  }, []);

  useEffect(() => {
    if (search.get('filter')) {
      setShowFilters(search.get('filter') === 'true');
      GetRelEstoque(getFiltroPadraoRelatorioEstoque());
    }
  }, [search]);

  const getPDF = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relEstoque, null, 2),
    };
    baixarArquivoBase64('/EstoqueReport/GetPDF', payload);
  };

  const getExcel = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relEstoque, null, 2),
    };
    baixarArquivoBase64('/EstoqueReport/GetExcel', payload);
  };

  return (
    <Pagina loading={loading}>
      <FormikPadrao
        initialValues={getFiltroPadraoRelatorioEstoque()}
        onSubmit={async values => {
          await GetRelEstoque(values);
        }}
      >
        <BarraBotoes
          maxWindowSize={1030}
          botoes={[
            {
              children: 'Exportar Planilha',
              onClick: getExcel,
              variant: 'verde',
            },
            {
              children: 'Exportar PDF',
              onClick: getPDF,
              variant: 'rosa',
            },
          ]}
          search={{
            placeholder: 'Procurar',
            onChange: e => setSearchBar(e.target.value),
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />
        <FilterMenu showFilters={showFilters} setShowFilters={setShowFilters} />
        <Tabela
          titulo={'RELATÓRIO DE ESTOQUE'}
          setFunction={setRelEstoque}
          data={relEstoque}
          columns={[
            {
              placeholder: 'CÓDIGO',
              name: 'Codigo',
              type: 'text',
            },
            {
              placeholder: 'PRODUTO',
              name: 'Descricao',
              type: 'text',
            },
            {
              placeholder: 'SALDO',
              name: 'Saldo',
              type: 'text',
            },
            {
              placeholder: 'ESTOQUE MÍNIMO',
              name: 'EstoqueMinimo',
              type: 'text',
            },
            {
              placeholder: 'ESTOQUE',
              name: 'Estoque',
              type: 'text',
            },
            {
              placeholder: 'EMPRESA',
              name: 'Empresa',
              type: 'text',
            },
          ]}
          searchBar={searchBar}
        />
      </FormikPadrao>
    </Pagina>
  );
}

function FilterMenu({ showFilters, setShowFilters }) {
  return (
    <Filtros showFilters={showFilters} setShowFilters={setShowFilters}>
      <InputFiltro
        titulo="EMPRESA"
        id="Empresa"
        name="Empresa"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Empresa'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="DEPÓSITO"
        id="Estoque"
        name="Estoque"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Deposito'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PRODUTO"
        id="Produto"
        name="Produto"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Produtos'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Mostrar somente produtos com saldo (diferente de 0)?"
        id="ApenasProdutosComSaldo"
        name="ApenasProdutosComSaldo"
        component={InputToggle}
        gridColumn={gridColumn.gc4}
      />
    </Filtros>
  );
}

export default RelEstoque;
